import { render, staticRenderFns } from "./AdditionalSetupRV3434.vue?vue&type=template&id=4b49ad3a&scoped=true"
import script from "./AdditionalSetupRV3434.vue?vue&type=script&lang=js"
export * from "./AdditionalSetupRV3434.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSetupRV3434.vue?vue&type=style&index=0&id=4b49ad3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49ad3a",
  null
  
)

export default component.exports